import React, { useContext, useEffect, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import {
  Container,
  ContentLayout,
  Header,
  NonCancelableCustomEvent,
} from "@amzn/awsui-components-console";
import { Navigation } from "../commons";
import { URLS } from "../../components/constants/appConstants";
import { HelpPane } from "./help-pane";
import RagaAvailabilityTable from "./raga-availability-table";
import { InitDomain } from "src/context/domain/domainContext";
import { configureDomain } from "src/auth/config";
import { FlareContextProvider } from "src/context/flare/FlareContextProvider";
import { useSettingsStore } from "src/stores/useSettingsStore";
import { resolveInitialPanelState } from "src/hooks/useInitialPanelState";

export function RagaAvailabilities() {
  const { navPanelBehavior, toolsPanelBehavior } = useSettingsStore();
  const [navigationOpen, setNavigationOpen] = React.useState(
    resolveInitialPanelState(true, navPanelBehavior),
  );
  const [toolsOpen, setToolsOpen] = useState(
    resolveInitialPanelState(true, toolsPanelBehavior),
  );
  const { setDomain } = useContext(InitDomain);

  useEffect(() => {
    setDomain("Global");
    return () => {
      setDomain(configureDomain);
    };
  }, []);

  const onToolsChangeFn = ({
    detail,
  }: NonCancelableCustomEvent<AppLayoutProps.ChangeDetail>) => {
    setToolsOpen(detail.open);
  };
  return (
    <FlareContextProvider>
      <AppLayout
        content={
          <ContentLayout
            header={<Header variant="h1">View Raga availabilities</Header>}
          >
            <Container>
              <RagaAvailabilityTable />
            </Container>
          </ContentLayout>
        }
        navigation={<Navigation activeHref={URLS.RAGA_AVAILABILITIES} />}
        navigationOpen={navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        tools={<HelpPane />}
        toolsOpen={toolsOpen}
        onToolsChange={onToolsChangeFn}
      />
    </FlareContextProvider>
  );
}
